import React, { useState, useMemo, useEffect, useRef } from 'react'
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table'
import {
  Box,
  Button,
  Typography,
} from '@mui/material'
import {
  FileDownload as ExportIcon,
  FileUpload as ImportIcon,
} from '@mui/icons-material'
import { getLeadtimeData, importarLeadtime, calcularLeadtime } from 'src/services/motosSnopServices'
import * as XLSX from 'xlsx'

const MaestroContainer = ({ onAlert }) => {
  const [leadtimeData, setLeadtimeData] = useState([])
  const tableRef = useRef(null)

  // Llamar al endpoint al inicializar el componente
  useEffect(() => {
    const fetchLeadtimeData = async () => {
      try {
        const response = await getLeadtimeData()
        console.log('Respuesta del endpoint leadtime_bq:', response)
        
        if (response && response.leadtime && Array.isArray(response.leadtime)) {
          // Mapear los datos del endpoint al formato que espera la tabla
          const mappedData = response.leadtime.map((item, index) => ({
            id: index + 1,
            pais: item.origen === 'CHINA' ? 'China' : 
                  item.origen === 'INDIA' ? 'India' : 
                  item.origen === 'JAPON' ? 'Japón' : 
                  item.origen === 'INDONESIA' ? 'Indonesia' :
                  item.origen === 'TAILANDIA' ? 'Tailandia' :
                  item.origen === 'MEXICO' ? 'México' :
                  item.origen === 'USA' ? 'Estados Unidos' : item.origen,
            proveedor: item.proveedor || '',
            origen: item.origen || '',
            puerto_origen: item.puerto_origen || '',
            puerto_destino: item.puerto_destino || '',
            pedidoAnticipado: item.pedido_de || '',
            diasPagoAnticipado: parseInt(item.dias_pago_anticipado, 10) || 0,
            dias_produccion: parseInt(item.dias_produccion, 10) || 0,
            diasHabilesProduccion: parseInt(item.dias_produccion_habil, 10) || 0,
            diasInspeccionCalidad: parseInt(item.dias_inspeccion_calidad, 10) || 0,
            diasSalidaPuerto: parseInt(item.dias_salida_puerto, 10) || 0,
            diasTransitoInternacional: parseInt(item.dias_transito_internacional, 10) || 0,
            diasTransporteInbound: parseInt(item.dias_transporte_inbound, 10) || 0,
            dias_produccion_au: parseInt(item.dias_produccion_au, 10) || 0,
            diasCalendarioProduccion: parseInt(item.dias_calendario_produccion, 10) || 0,
            diasTotal: parseInt(item.Total, 10) || 0,
            fechaPedido: item.fecha_pedido || '',
            fechaCargaLista: item.fecha_carga_lista_a_inspeccion || '',
            fechaLlegadaPlanta: item.fecha_llegada_planta || '',
            fechaDisponibleFacturacion: item.fecha_disponible_para_facturacion || '',
            diferenciaMesesVsSiguiente: parseInt(item.diferencia_en_meses_vs_siguiente_fecha_llegada, 10) || 0,
          }))
          
          setLeadtimeData(mappedData)
        }
      } catch (error) {
        console.error('Error al obtener datos de leadtime:', error)
      }
    }
    
    fetchLeadtimeData()
  }, [])

  const handleImport = async (event) => {
    const file = event.target.files[0]
    if (file) {
      try {
        const result = await importarLeadtime(file)
        if (result.success) {
          onAlert(result.message)
          // Recargar los datos después de la importación exitosa
          const response = await getLeadtimeData()
          if (response && response.leadtime && Array.isArray(response.leadtime)) {
            const mappedData = response.leadtime.map((item, index) => ({
              id: index + 1,
              pais: item.origen === 'CHINA' ? 'China' : 
                    item.origen === 'INDIA' ? 'India' : 
                    item.origen === 'JAPON' ? 'Japón' : 
                    item.origen === 'INDONESIA' ? 'Indonesia' :
                    item.origen === 'TAILANDIA' ? 'Tailandia' :
                    item.origen === 'MEXICO' ? 'México' :
                    item.origen === 'USA' ? 'Estados Unidos' : item.origen,
                          proveedor: item.proveedor || '',
            origen: item.origen || '',
            puerto_origen: item.puerto_origen || '',
            puerto_destino: item.puerto_destino || '',
            pedidoAnticipado: item.pedido_de || '',
              diasPagoAnticipado: parseInt(item.dias_pago_anticipado, 10) || 0,
              dias_produccion: parseInt(item.dias_produccion, 10) || 0,
              diasHabilesProduccion: parseInt(item.dias_produccion_habil, 10) || 0,
              diasInspeccionCalidad: parseInt(item.dias_inspeccion_calidad, 10) || 0,
              diasSalidaPuerto: parseInt(item.dias_salida_puerto, 10) || 0,
              diasTransitoInternacional: parseInt(item.dias_transito_internacional, 10) || 0,
              diasTransporteInbound: parseInt(item.dias_transporte_inbound, 10) || 0,
              dias_produccion_au: parseInt(item.dias_produccion_au, 10) || 0,
              diasCalendarioProduccion: parseInt(item.dias_calendario_produccion, 10) || 0,
              diasTotal: parseInt(item.Total, 10) || 0,
              fechaPedido: item.fecha_pedido || '',
              fechaCargaLista: item.fecha_carga_lista_a_inspeccion || '',
              fechaLlegadaPlanta: item.fecha_llegada_planta || '',
              fechaDisponibleFacturacion: item.fecha_disponible_para_facturacion || '',
              diferenciaMesesVsSiguiente: parseInt(item.diferencia_en_meses_vs_siguiente_fecha_llegada, 10) || 0,
            }))
            setLeadtimeData(mappedData)
          }
        } else {
          onAlert(result.message)
        }
      } catch (error) {
        console.error('Error al importar archivo:', error)
        onAlert('Error al procesar el archivo de importación')
      }
      // Limpiar el input
      event.target.value = ''
    }
  }

  // Función para manejar la edición de celdas
  const handleSaveCell = ({ cell, value }) => {
    const rowIndex = cell.row.index
    const columnId = cell.column.id
    
    setLeadtimeData(prev => 
      prev.map((row, index) => 
        index === rowIndex 
          ? { ...row, [columnId]: parseInt(value, 10) || 0 }
          : row
      )
    )
    
    onAlert(`${columnId === 'diasHabilesProduccion' ? 'Días Hábiles Producción' : 'Diferencia en meses'} actualizado exitosamente`)
  }

  const handleCalcular = async () => {
    try {
      const result = await calcularLeadtime()
      if (result.success) {
        onAlert(result.message)
        // Recargar los datos después del cálculo exitoso
        const response = await getLeadtimeData()
        if (response && response.leadtime && Array.isArray(response.leadtime)) {
          const mappedData = response.leadtime.map((item, index) => ({
            id: index + 1,
            pais: item.origen === 'CHINA' ? 'China' : 
                  item.origen === 'INDIA' ? 'India' : 
                  item.origen === 'JAPON' ? 'Japón' : 
                  item.origen === 'INDONESIA' ? 'Indonesia' :
                  item.origen === 'TAILANDIA' ? 'Tailandia' :
                  item.origen === 'MEXICO' ? 'México' :
                  item.origen === 'USA' ? 'Estados Unidos' : item.origen,
            proveedor: item.proveedor || '',
            origen: item.origen || '',
            pedidoAnticipado: item.pedido_de || '',
            diasPagoAnticipado: parseInt(item.dias_pago_anticipado, 10) || 0,
            dias_produccion: parseInt(item.dias_produccion, 10) || 0,
            diasHabilesProduccion: parseInt(item.dias_produccion_habil, 10) || 0,
            diasInspeccionCalidad: parseInt(item.dias_inspeccion_calidad, 10) || 0,
            diasSalidaPuerto: parseInt(item.dias_salida_puerto, 10) || 0,
            diasTransitoInternacional: parseInt(item.dias_transito_internacional, 10) || 0,
            diasTransporteInbound: parseInt(item.dias_transporte_inbound, 10) || 0,
            dias_produccion_au: parseInt(item.dias_produccion_au, 10) || 0,
            diasCalendarioProduccion: parseInt(item.dias_calendario_produccion, 10) || 0,
            diasTotal: parseInt(item.Total, 10) || 0,
            fechaPedido: item.fecha_pedido || '',
            fechaCargaLista: item.fecha_carga_lista_a_inspeccion || '',
            fechaLlegadaPlanta: item.fecha_llegada_planta || '',
            fechaDisponibleFacturacion: item.fecha_disponible_para_facturacion || '',
            diferenciaMesesVsSiguiente: parseInt(item.diferencia_en_meses_vs_siguiente_fecha_llegada, 10) || 0,
          }))
          setLeadtimeData(mappedData)
        }
      } else {
        onAlert(result.message)
      }
    } catch (error) {
      console.error('Error al calcular leadtime:', error)
      onAlert('Error al ejecutar el cálculo de leadtime')
    }
  }

  const handleExport = () => {
    if (!tableRef.current) return

    try {
      // Get the current table state
      const tableInstance = tableRef.current
      
      // Get only visible columns
      const visibleColumns = tableInstance.getAllColumns()
        .filter(col => col.getIsVisible())

      // Get filtered rows
      const filteredRows = tableInstance.getFilteredRowModel().rows

      // Create headers for Excel
      const headers = visibleColumns.map(col => {
        // Special case for the country column
        if (col.id === 'pais') return 'País'
        return col.columnDef.header
      })

      // Create rows of data
      const rows = filteredRows.map(row => 
        visibleColumns.map(col => {
          const value = row.getValue(col.id)
          // Special case for the country column - get the raw value without the flag
          if (col.id === 'pais') {
            const countryCell = row.original.pais
            return countryCell || ''
          }
          // Handle special formatting for certain columns
          if (col.id === 'dias_produccion_au' || col.id === 'diferenciaMesesVsSiguiente') {
            return value || 0
          }
          return value || ''
        })
      )

      // Create worksheet
      const ws = XLSX.utils.aoa_to_sheet([headers, ...rows])

      // Set column widths
      const colWidths = visibleColumns.map(col => ({
        wch: Math.max(
          col.columnDef.header.length,
          ...rows.map(row => String(row[visibleColumns.indexOf(col)]).length)
        ) + 2 // Add some padding
      }))
      ws['!cols'] = colWidths

      // Create workbook
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Leadtime')

      // Generate Excel file
      XLSX.writeFile(wb, `leadtime_maestro_${new Date().toISOString().split('T')[0]}.xlsx`)

      onAlert('Archivo Excel descargado exitosamente')
    } catch (error) {
      console.error('Error al exportar:', error)
      onAlert('Error al descargar el archivo')
    }
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: 'proveedor',
        header: 'Proveedor',
        size: 120,
        enableEditing: false,
      },
      // {
      //   accessorKey: 'pais',
      //   header: 'País',
      //   size: 100,
      //   enableEditing: false,
      //   Cell: ({ cell }) => {
      //     const pais = cell.getValue()
      //     let bandera = ''
      //     switch (pais) {
      //       case 'China':
      //         bandera = '🇨🇳'
      //         break
      //       case 'India':
      //         bandera = '🇮🇳'
      //         break
      //       case 'Japón':
      //         bandera = '🇯🇵'
      //         break
      //       case 'Indonesia':
      //         bandera = '🇮🇩'
      //         break
      //       case 'Tailandia':
      //         bandera = '🇹🇭'
      //         break
      //       case 'México':
      //         bandera = '🇲🇽'
      //         break
      //       case 'Estados Unidos':
      //         bandera = '🇺🇸'
      //         break
      //       default:
      //         bandera = ''
      //     }
      //     return (
      //       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      //         <span style={{ fontSize: '18px' }}>{bandera}</span>
      //         <Typography variant="body2">{pais}</Typography>
      //       </Box>
      //     )
      //   },
      // },
      
      {
        accessorKey: 'origen',
        header: 'Pais origen',
        size: 120,
        enableEditing: false,
      },
      {
        accessorKey: 'puerto_origen',
        header: 'Puerto origen',
        size: 120,
        enableEditing: false,
      },
      {
        accessorKey: 'puerto_destino',
        header: 'Puerto destino',
        size: 120,
        enableEditing: false,
      },
      {
        accessorKey: 'pedidoAnticipado',
        header: 'Pedido de',
        size: 150,
        enableEditing: false,
      },
      {
        accessorKey: 'diasPagoAnticipado',
        header: 'Días Pago Antic',
        size: 120,
        enableEditing: false,
      },
      {
        accessorKey: 'dias_produccion',
        header: 'Días Producción',
        size: 120,
        enableEditing: false,
      },
      {
        accessorKey: 'diasHabilesProduccion',
        header: 'Días Hábiles Producción',
        size: 140,
        enableEditing: true,
        muiEditTextFieldProps: {
          type: 'number',
          variant: 'outlined',
          size: 'small',
        },
        Cell: ({ cell }) => (
          <Typography 
            variant="body2" 
            sx={{ 
              backgroundColor: '#e8f5e8',
              padding: '4px 8px',
              borderRadius: '4px',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: '#d4edda',
              }
            }}
          >
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: 'diasCalendarioProduccion',
        header: 'Días Calendario Prod',
        size: 160,
        enableEditing: false,
      },
      {
        accessorKey: 'diasInspeccionCalidad',
        header: 'Días Inspec Calidad',
        size: 140,
        enableEditing: false,
      },
      {
        accessorKey: 'diasSalidaPuerto',
        header: 'Días Salida Puerto',
        size: 120,
        enableEditing: false,
      },
      {
        accessorKey: 'diasTransitoInternacional',
        header: 'Días Tránsito Int',
        size: 160,
        enableEditing: false,
      },
      {
        accessorKey: 'diasTransporteInbound',
        header: 'Días Transporte Inbound',
        size: 150,
        enableEditing: false,
      },
      {
        accessorKey: 'dias_produccion_au',
        header: 'Días Producción AU',
        size: 120,
        enableEditing: false,
      },
     
      {
        accessorKey: 'diasTotal',
        header: 'Días Total',
        size: 100,
        enableEditing: false,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight="bold" color="primary">
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: 'fechaPedido',
        header: 'Fecha Pedido',
        size: 120,
        enableEditing: false,
      },
      {
        accessorKey: 'fechaCargaLista',
        header: 'Fecha Carga Lista',
        size: 130,
        enableEditing: false,
      },
      {
        accessorKey: 'fechaLlegadaPlanta',
        header: 'Fecha Llegada Planta',
        size: 140,
        enableEditing: false,
      },
      {
        accessorKey: 'fechaDisponibleFacturacion',
        header: 'Fecha Disponible Facturación',
        size: 180,
        enableEditing: false,
      },
      {
        accessorKey: 'diferenciaMesesVsSiguiente',
        header: 'Diferencia meses vs siguiente',
        size: 180,
        enableEditing: true,
        muiEditTextFieldProps: {
          type: 'number',
          variant: 'outlined',
          size: 'small',
        },
        Cell: ({ cell }) => (
          <Typography 
            variant="body2" 
            sx={{ 
              backgroundColor: '#fff3cd',
              padding: '4px 8px',
              borderRadius: '4px',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: '#ffeaa7',
              }
            }}
          >
            {cell.getValue()}
          </Typography>
        ),
      },
    ],
    []
  )

  const table = useMaterialReactTable({
    columns,
    data: leadtimeData,
    enableColumnActions: false,
    enableColumnFilters: true,
    enablePagination: true,
    enableSorting: true,
    enableBottomToolbar: true,
    enableTopToolbar: true,
    enableEditing: true,
    editDisplayMode: 'cell',
    onEditingCellSave: handleSaveCell,
    muiTableBodyRowProps: {
      sx: {
        '&:hover': {
          backgroundColor: '#f5f5f5',
        },
      },
    },
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: '#4c75aa',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '13px',
        textAlign: 'center',
        '& .MuiTableSortLabel-root': {
          color: 'white',
        },
        '& .MuiTableSortLabel-root:hover': {
          color: '#e3f2fd',
        },
        '& .MuiTableSortLabel-icon': {
          color: 'white !important',
        },
      },
    },
    muiTablePaperProps: {
      elevation: 2,
      sx: {
        borderRadius: 2,
      },
    },
    renderTopToolbarCustomActions: () => (
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant="outlined"
          startIcon={<ExportIcon />}
          onClick={handleExport}
          sx={{
            borderColor: '#4c75aa',
            color: '#4c75aa',
            '&:hover': {
              backgroundColor: '#e3f2fd',
              borderColor: '#4c75aa',
            },
          }}
        >
          Exportar
        </Button>
        <Button
          variant="outlined"
          startIcon={<ImportIcon />}
          component="label"
          sx={{
            borderColor: '#4c75aa',
            color: '#4c75aa',
            '&:hover': {
              backgroundColor: '#e3f2fd',
              borderColor: '#4c75aa',
            },
          }}
        >
          Importar
          <input
            type="file"
            hidden
            accept=".xlsx,.xls"
            onChange={handleImport}
          />
        </Button>
      </Box>
    ),
  })

  // Store table instance in ref
  useEffect(() => {
    tableRef.current = table
  }, [table])

  return (
    <Box>
      <MaterialReactTable table={table} />
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Button
          variant="contained"
          onClick={handleCalcular}
          sx={{
            backgroundColor: '#4c75aa',
            color: 'white',
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: '#3a5a85',
            },
          }}
        >
          Calcular
        </Button>
      </Box>
    </Box>
  )
}

export default MaestroContainer